module.exports = __webpack_public_path__ + "static/media/peterharmschalk.927c44ef.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/peterharmschalk.webp
// module id = 216
// module chunks = 0